export default "__VITE_ASSET__Ds91Mee$__"